import { Box, Center, Grid, Group, LoadingOverlay, Stack } from '@ui';

import { Info } from '..';

export const SummaryLoader = ({ message }: { message: string }) => {
  return (
    <Group justify="center">
      <Grid>
        <Grid.Col span={{ base: 12, md: 10 }}>
          <Stack h="50vh" w="100%" justify="center" align="center">
            <Info dittoIcon type="info" info={message} loading />
          </Stack>
        </Grid.Col>
      </Grid>
    </Group>
  );
};

export const SmallLoader = ({ message }: { message: string }) => {
  return <Info dittoIcon type="info" info={message} loading />;
};

export const FormLoader = ({
  message,
  boxMaxWidth
}: {
  message: string;
  boxMaxWidth?: number;
}) => {
  return (
    <Box mt={-20} {...(boxMaxWidth ? { maw: boxMaxWidth } : {})}>
      <Info dittoIcon type="info" info={message} loading />
    </Box>
  );
};

export const PageLoader = () => (
  <Center h="100dvh">
    <LoadingOverlay
      visible
      zIndex={10001}
      overlayProps={{ radius: 'sm', blur: 1 }}
    />
  </Center>
);
